(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvDocumentTemplateEditorHtml', drvDocumentTemplateEditorHtml);

    /**
     * @ngdoc directive
     * @name drvDocumentTemplateEditorHtml
     *
     * @description
     * Editor for HTML document template.
     *
     *
     * # Scope Properties
     * {string} value
     * {EntityTemplate} entityTemplate
     * {bool} readonly
     */
    function drvDocumentTemplateEditorHtml() {
        return {
            templateUrl: 'app/documenttemplate/document-template-editor-html.tmpl.html',
            require: 'ngModel',
            scope: {
                value: '=ngModel',
            },
            controller: DocumentTemplateEditorHtmlCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=ngModel',
                readonly: '<?',
                entityTemplate: '<'
            }
        };
    }

    DocumentTemplateEditorHtmlCtrl.$inject = [];

    function DocumentTemplateEditorHtmlCtrl() {
        var drvCtrl = this;
    }
})();